import classes from './ContentWidthLimiter.module.scss';

const ContentWidthLimiter = ({ children }) => {
	return (
		<div className="container">
			<div className="row">
				<div className="col-12 col-xl-8">{children}</div>
				<div className="col-0 col-xl-4"></div>
			</div>
		</div>
	);
};

export default ContentWidthLimiter;
